import { useEffect, useState } from "react";
import { analytics } from "../firebase/firebase"; // yolu doğru verdiğine emin ol
import { logEvent } from "firebase/analytics";


export const useConfig = (params) => {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (params == null) return;

    const { id, company, key, service } = params;

    if (!id || !company || !key || !service) {
      setError("Gerekli parametreler eksik. Lütfen bağlantınızı kontrol edin!");
      return;
    }

    // 🎯 Firebase Analytics log
    try {
      logEvent(analytics, "3d_open", {
        company: company,
        project_id: id
      });
    } catch (err) {
      console.warn("Firebase log hatası:", err);
    }

    // 🔧 Config alma
    let url = `https://api.albertgenauapp.com/projectitem/balcony3d?project_item_id=${params.id}`;

    console.log(url);
    fetch(url, {
      method: "GET",
      headers: {
        "Auth-Key": params.key,
        "Client-Service": params.service,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Sunucu hatası: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (!data) throw new Error("Gelen veri boş.");

        // ✨ Sections kontrolü burada:
        if (!Array.isArray(data.sections) || data.sections.length === 0) {
          setError("Proje çizimi henüz tamamlanmamış. Lütfen çizimi tamamladıktan sonra 3D görüntülemeyi açın.");
          return;
        }

        setConfig(data);
      })
      .catch((err) => {
        console.error("Config fetch error:", err);
        setError("Veri alınamadı. Daha sonra tekrar deneyin.");
      });
  }, [params]);

  return { config, error };
};
